import { HeartButton } from 'components/HeartButton';
import { useLike } from 'components/HeartButton/HeartButton.hooks';
import { OpinionModel } from 'components/Opinion/Opinion.hooks';
import { Link } from 'react-router-dom';

export type ArticleFooterProps = OpinionModel;

export const ArticleFooter = ({ id, likesCount, createdAt }: ArticleFooterProps) => {
  const { isLiked, onLikeClick } = useLike(id);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <Link to={`/articles/${id}`} className="text-muted text-decoration-none"><small>{createdAt.toDate().toLocaleString()}</small></Link>
      <HeartButton isLiked={isLiked} likesCount={likesCount} onClick={onLikeClick} />
    </div>
  );
};
